export class MasterSolutionDetailImportModel {
    counter: number = 0;
    masterSolutionId: number = 0;
    consecutiveMasterSolution: number = 0;
    articleCode: number = 0;
    articleName: string = "";
    quantity: number = 0;

    constructor(
        counter: number = 0,
        masterSolutionId: number = 0,
        consecutiveMasterSolution: number = 0,
        articleCode: number = 0,
        articleName: string = "",
        quantity: number = 0
    ) {
        this.counter = counter;
        this.masterSolutionId = masterSolutionId;
        this.consecutiveMasterSolution = consecutiveMasterSolution;
        this.articleCode = articleCode;
        this.articleName = articleName;
        this.quantity = quantity;
    }
}